import service from './RestService';
import { RestResponse } from '../types/response/RestResponse';
import BookingExternal from '../types/model/BookingExternal';
import { BlockedBookingSlotData } from '../state/bookings/types';
import Booking from '../types/model/Booking';

const path = '/booking';

class BookingService {
  getFreeSlotsExternal = (projectId: number, transportEquipmentId: number, date: string, deliveryDuration: number): RestResponse<BookingExternal[]> =>
    service.get(`${path}/free-slots-external/${projectId}`, { transportEquipmentId, date, deliveryDuration });

  blockBookingSlot = (data: BlockedBookingSlotData): RestResponse<null> => service.post(`${path}/add-blocking-slot`, data);

  cancelActiveBookings = (bookingIds: string, type?: string): RestResponse<null> =>
    service.post(`${path}/cancel/${bookingIds}`, { reason: type, reasonText: '' });

  unblockAllDates = (projectId: number): RestResponse<null> => service.post(`${path}/unblock-all?projectId=${projectId}`);

  unblockDate = (slotIds: string): RestResponse<null> => service.post(`${path}/remove-blocking-slots?slotIds=${slotIds}`);

  getBookingConfirmation = (bookingId: number): RestResponse<null> => service.get(`${path}/confirmation-pdf/${bookingId}`);

  sendBookingEmail = (bookingId: number): RestResponse<null> => service.post(`${path}/${bookingId}/booking-confirmation-notification`);

  editBookings = (bookingId: number, data: Partial<Booking>): RestResponse<null> => service.put(`${path}/${bookingId}`, data);

  editPendingBooking = (bookingId: number, data: Partial<Booking>) => service.post(`${path}/${bookingId}/edit-and-confirm`, data);
}
export default new BookingService();
